import React from "react";

// Decorative olive branch SVG used as section accent
export const OliveBranch = ({ className = "", flip = false }) => (
  <svg
    viewBox="0 0 120 40"
    fill="none"
    className={className}
    style={flip ? { transform: "scaleX(-1)" } : undefined}
    aria-hidden="true"
  >
    <path
      d="M2 20 C 30 20, 60 20, 116 20"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    {[18, 34, 50, 66, 82, 98].map((x, i) => (
      <g key={i}>
        <ellipse
          cx={x}
          cy={11}
          rx="6"
          ry="3.2"
          transform={`rotate(-32 ${x} 11)`}
          fill="currentColor"
          opacity="0.85"
        />
        <ellipse
          cx={x + 8}
          cy={29}
          rx="6"
          ry="3.2"
          transform={`rotate(32 ${x + 8} 29)`}
          fill="currentColor"
          opacity="0.85"
        />
      </g>
    ))}
    <circle cx="60" cy="20" r="2.4" fill="currentColor" />
  </svg>
);

export default OliveBranch;
